module.exports = __webpack_public_path__ + "static/media/ncj_pend_0006.9ea61ea2.jpg";